module.exports = __webpack_public_path__ + "static/media/C.476c466b.png";